export function destinazioneArticolo(location, codVS) {
  const params = new URLSearchParams(location.search);
  params.set("articolo", String(codVS));
  return { pathname: location.pathname, search: `?${params}`, hash: location.hash };
}
